/* import __COLOCATED_TEMPLATE__ from './fin-studio-entry-point.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';

interface Signature {
  Args: {};
}

export default class FinStudioEntryPoint extends Component<Signature> {
  @service declare aiAgentSetupService: AiAgentSetupService;

  get finIsLive(): boolean {
    return !!this.aiAgentSetupService.isFinLive;
  }
}
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAutomation::FinStudioEntryPoint': typeof FinStudioEntryPoint;
  }
}
